"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _core = _interopRequireDefault(require("../utils/core"));

var _jquery = _interopRequireDefault(require("../utils/jquery.webf"));

require("./inputautogrow");

var _jquery2 = _interopRequireDefault(require("jquery"));

/**
 * @options
 *  - separator:            (string)    Séparateur des tags dans l'input
 *  - tags                  ([string]|[Tag]) tags initiaux.
 *  - tagsInputClass        (string) Classes CSS à ajouter sur la zone de texte handler
 *  - tagClass              (string) Classes CSS à ajouter aux tags
 *  - confirmKeys           ([int]) KeyCodes des touches servant à valider un tag après saisie
 *  - onTagClick            (function($tag, tag)) Fonction appelée lorsqu'un clic survient sur un tag
 *  - onBeforeTagAdd        (function($tag, tag)) Fonction appelée juste avant qu'un tag est ajouté
 *  - onTagAdd              (function($tag, tag)) Fonction appelée juste après qu'un a été ajouté
 *  - onBeforeTagRemove     (function($tag, tag)) Fonction appelée juste avant qu'un tag est supprimé
 *  - onTagRemove           (function()) Fonction appelée juste après qu'un a été supprimé
 *  - onTagFocus            (function($tag, tag)) Fonction appelée lorsqu'un tag prend le focus
 *
 * @methods
 *  - appendTag(tag)        Ajoute un tag
 *  - removeTag(tag)        Supprime un tag
 *  - removeAllTags()       Supprime tous les tags
 *  - tags()                Retourne les tags
 *  - input()               Retourne la zone d'input
 *  - container()           Retourne l'élément HTML du conteneur des tags
 *
 * Structures:
 *  Tag {
 *   - label (string)
 *   - value (mixed)
 *  }
 */
(0, _jquery["default"])('tagsinput', {
  options: {
    separator: ',',
    tags: [],
    tagsInputClass: '',
    tagClass: '',
    confirmKeys: [13, 'Enter'],
    onTagClick: _core["default"].noop,
    onBeforeTagAdd: _core["default"].noop,
    onTagAdd: _core["default"].noop,
    onBeforeTagRemove: _core["default"].noop,
    onTagRemove: _core["default"].noop,
    onTagFocus: _core["default"].noop
  },
  _create: function _create() {
    var $tagsInput = (0, _jquery2["default"])("<div>").prop('tabIndex', -1).addClass('webf-tagsinput ' + this.option('tagsInputClass').split(' ').join(' '));
    this.$input = (0, _jquery2["default"])("<input>").addClass('webf-tagsinput-text').prop('enterkeyhint', 'done').prop('autocomplete', 'off').prop('type', 'text');

    if (this.e.attr('inputmode')) {
      this.$input.attr('inputmode', this.e.attr('inputmode'));
    }

    this.e.hide().wrap($tagsInput);
    this.$tagsInput = this.e.parent().prepend(this.$input);
    this.placeholder = this.e.attr('placeholder') || '';

    if (!this.$input.closest('form')[0]) {
      this.$input.wrap((0, _jquery2["default"])('<form>').css({
        display: 'inline'
      }));
    } else {
      this.$input.wrap((0, _jquery2["default"])('<span>'));
    }

    var $form = this.$input.closest('form');
    var $wrapperInput = this.$input.parent();

    if (!$form.find('[type="submit"]')[0]) {
      $wrapperInput.append((0, _jquery2["default"])("<input>").prop('type', 'submit').css({
        position: 'absolute',
        left: '-9999px',
        top: '-9999px'
      }));
    }

    this._initTags();

    if (!this.tags().length) {
      this.$input.addClass('empty').prop('placeholder', this.placeholder);
    } else {
      this._enableAutogrow();
    }

    this._bindEvents();
  },
  _enableAutogrow: function _enableAutogrow() {
    this.$input.webfInputautogrow({
      minWidth: 10,
      extraWidth: 10
    });
  },
  _disableAutogrow: function _disableAutogrow() {
    try {
      this.$input.webfInputautogrow('destroy');
    } catch (e) {}
  },
  _bindEvents: function _bindEvents() {
    var _this = this;

    this._on(this.$tagsInput, {
      click: function click() {
        _this._trigger(_this.$input, 'focus');
      }
    })._on(this.$tagsInput, '.webf-tag', {
      click: function click(ev) {
        ev.stopPropagation();

        _this._call(_this.option('onTagClick'), (0, _jquery2["default"])(ev.currentTarget), (0, _jquery2["default"])(ev.currentTarget).data('tag'));
      },
      focus: function focus(ev) {
        ev.stopPropagation();

        _this._call(_this.option('onTagFocus'), (0, _jquery2["default"])(ev.currentTarget), (0, _jquery2["default"])(ev.currentTarget).data('tag'));
      }
    })._on(this.$tagsInput, '.remove', {
      click: function click(ev) {
        ev.stopPropagation();

        _this.removeTag((0, _jquery2["default"])(ev.currentTarget).closest('.webf-tag').data('tag'));
      }
    })._on(this.$input, {
      focus: function focus(ev) {
        if (_this.tags().length) {
          _this._enableAutogrow();
        }
      }
    });

    this._on(this.$tagsInput, '.webf-tag', {
      keydown: function keydown(ev) {
        switch (ev.key) {
          case 'Backspace': // 8

          case 'Delete':
            // 46
            ev.preventDefault();

            _this.removeTag((0, _jquery2["default"])(ev.currentTarget).data('tag'));

            var $tag = _this.$tagsInput.children('.webf-tag').last();

            if ($tag[0]) {
              _this._focusTag($tag);
            } else {
              _this.$input.trigger('focus');
            }

            break;

          case 'ArrowLeft':
            // 37
            var $prevTags = (0, _jquery2["default"])(ev.currentTarget).prevAll('.webf-tag');

            if ($prevTags.length) {
              _this._focusTag($prevTags.first());
            }

            break;

          case 'ArrowRight':
            // 39
            var $nextTags = (0, _jquery2["default"])(ev.currentTarget).nextAll('.webf-tag');

            if ($nextTags.length) {
              _this._focusTag($nextTags.first());
            } else {
              _this.$input.trigger('focus');
            }

            break;
        }
      }
    });

    this._on(this.$input, {
      // focusout: (ev) => {
      //     if (webf.isTouchDevice() && webf.isArray(this.option('confirmKeys')) && this.option('confirmKeys').length) {
      //         var e = $.Event('keydown');
      //         e.which = this.option('confirmKeys')[0];
      //         this.$input.trigger(e);
      //     }
      // },
      keydown: function keydown(ev) {
        if (_core["default"].inArray(ev.which, _this.option('confirmKeys') || _core["default"].inArray(ev.key, _this.option('confirmKeys')))) {
          var val = _this.$input.val();

          ev.preventDefault();

          if (val.length) {
            _this.appendTag(val);

            _this.$input.val('');
          }

          _this.$input.trigger('focus');
        } else {
          switch (ev.key) {
            case 'Backspace':
              // 8
              var _val = _this.$input.val();

              if (!_val.length) {
                ev.preventDefault();

                _this._focusTag(_this.$tagsInput.children('.webf-tag').last());
              }

              break;

            case 'ArrowLeft':
              // 37
              if (_core["default"].getCaretPosition(_this.$input[0]) === 0) {
                _this._focusTag(_this.$tagsInput.children('.webf-tag').last());
              }

              break;
          }
        }
      }
    });
  },
  _initTags: function _initTags() {
    this._tags = [];
    var tags = this.option('tags').length ? this.option('tags') : this.e.val().length ? this.e.val().split(this.option('separator')) : [];

    _core["default"].each(tags, function (i, tag) {
      var $tag = this._createTag(tag);

      this._tags.push($tag.data('tag')); // this.$input.before($tag);


      this.$input.parent().before($tag);
    }, this);
  },
  _createTag: function _createTag(tag) {
    var textTag = _core["default"].isObject(tag) ? tag.label : tag.trim();
    var valueTag = _core["default"].isObject(tag) ? tag.value : tag.trim();

    if (_core["default"].isUndefined(textTag) || _core["default"].isUndefined(valueTag || !textTag.length)) {
      return;
    }

    tag = {
      label: textTag,
      value: valueTag
    };
    return (0, _jquery2["default"])('<span>').addClass('webf-tag ' + this.option('tagClass')).prop('tabIndex', -1).html(textTag.replace(/\s/g, '&nbsp;')).data('tag', tag).data('label', textTag).data('value', valueTag).append((0, _jquery2["default"])('<span>').addClass('remove').append((0, _jquery2["default"])("<i class='fas fa-times'>")));
  },
  _focusTag: function _focusTag($tag) {
    this._trigger($tag, 'focus');
  },
  appendTag: function appendTag(tag) {
    tag = _core["default"].isObject(tag) ? tag : {
      label: tag,
      value: tag
    };
    var textTag = _core["default"].isObject(tag) ? tag.label : tag.trim();
    var valueTag = _core["default"].isObject(tag) ? tag.value : tag.trim();

    if (_core["default"].isUndefined(textTag) || _core["default"].isUndefined(valueTag || !textTag.length)) {
      return;
    }

    if (this._call(this.option('onBeforeTagAdd'), tag) !== false) {
      this._tags.push(tag);

      var $tag = this._createTag(tag); // this.$input.before($tag);


      this.$input.parent().before($tag);
      this.$input.prop('placeholder', '').removeClass('empty');

      this._enableAutogrow();

      this._call(this.option('onTagAdd'), $tag, tag);
    }
  },
  removeTag: function removeTag(tag, all) {
    var tagValue = _core["default"].isObject(tag) ? tag.value : tag;

    this._tags.reverse();

    _core["default"].each(this._tags, function (i, aTag) {
      var aTagValue = _core["default"].isObject(aTag) ? aTag.value : aTag;

      if (aTagValue == tagValue) {
        var $tag = this.$tagsInput.children('.webf-tag').findByData('value', tagValue).first();

        if (this._call(this.option('onBeforeTagRemove'), $tag, $tag.data('tag')) !== false) {
          $tag.remove();

          this._tags.splice(i, 1);

          if (!this.tags().length) {
            this._disableAutogrow();

            this.$input.prop('placeholder', this.placeholder).addClass('empty');
          }

          this._call(this.option('onTagRemove'));
        }

        return !!all;
      }
    }, this);

    this._tags.reverse();
  },
  removeAllTags: function removeAllTags() {
    _core["default"].each(this.tags(), function (i, tag) {
      this.removeTag(tag);
    }, this);
  },
  tags: function tags() {
    return this._tags;
  },
  input: function input() {
    return this.$input;
  },
  container: function container() {
    return this.$tagsInput;
  },
  _destroy: function _destroy() {
    this._disableAutogrow(); // this.$input.remove();


    this.$input.parent().remove();
    this.$tagsInput.children('.webf-tag').remove();
    this.e.show().unwrap().removeClass('webf-tagsinput');
  }
});